module.exports = __webpack_public_path__ + "img/habitacion.28d43bfb.svg";